import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { FormButton, SelectInputBox } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const SMSTemplateMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: '', SortOrder: '' });
    const [formData, setFormData] = useState({
        SMSTemplateId: '',
        serviceProviderID: '',
        senderID: '',
        productFamilyCode: '',
        dealerTypeCode: '',
        smsText: '',
        smsType: 'OTP',
        OTP: false,
        loginOTP: false,
        CommanSMS: false,
    });
    const GeDealerType = DropDownData('GetDealerTypeMaster')
    const GetSenderIdCode = DropDownData('GetSenderID', formData.serviceProviderID)
    const GetProductFamilyCode = DropDownData('GetProductFamilyMaster')
    const GetServiceProviderCode = DropDownData('GetServiceProvider')


    const getSMSTemplateMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            dealerTypeCode: formData.dealerTypeCode || '',
            senderID: formData.senderID || '0',
            smsText: formData.smsText || '',
            OTP: formData.OTP || false,
            loginOTP: formData.loginOTP || false,
            CommanSMS: formData.CommanSMS || false,
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/GeneralSetting/ShowSMSTemplateMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            SMSTemplateId: '',
            serviceProviderID: '',
            senderID: '0',
            productFamilyCode: '',
            dealerTypeCode: '',
            smsText: '',
            smsType: 'OTP',
            OTP: false,
            loginOTP: false,
            CommanSMS: false,
        });
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/GeneralSetting/InsertUpdateSMSTemplateMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };
    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/GeneralSetting/EditSMSTemplateMaster`, { SMSTemplateId: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }
    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/GeneralSetting/DeleteSMSTemplateMaster`, { SMSTemplateId: id }, getSMSTemplateMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }
    const handleChange = (e) => {
        setFormData({ ...formData, smsType: e.target.value });
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getSMSTemplateMasterData(value);
    };

    useEffect(() => {
        getSMSTemplateMasterData()
        document.title = 'SMS Template Master'
        inputrefs.current['txtServiceProvider'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1 d-flex gap-4'>
                        <h6 className="m-0">  {'SMS Template Master'} </h6>
                        <div className="row" style={{ display: 'none' }}>
                            <div className="col-lg-2 col-md-2 col-sm-12 mb-1">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="otp"
                                        name="smsType"
                                        value="OTP"
                                        checked={formData.smsType === 'OTP'}
                                        onChange={handleChange}
                                        ref={(el) => (inputrefs.current['otp'] = el)}
                                    />
                                    <label htmlFor="otp" className="form-check-label ms-2" style={{ textWrap: "nowrap" }}>
                                        OTP
                                    </label>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-2 col-sm-12 mb-1">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="loginOTP"
                                        name="smsType"
                                        value="Login OTP"
                                        checked={formData.smsType === 'Login OTP'}
                                        onChange={handleChange}
                                        ref={(el) => (inputrefs.current['loginOTP'] = el)}
                                    />
                                    <label htmlFor="loginOTP" className="form-check-label ms-2" style={{ textWrap: "nowrap" }}>
                                        Login OTP
                                    </label>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-2 col-sm-12 mb-1">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="commanSMS"
                                        name="smsType"
                                        value="Comman SMS"
                                        checked={formData.smsType === 'Comman SMS'}
                                        onChange={handleChange}
                                        ref={(el) => (inputrefs.current['commanSMS'] = el)}
                                    />
                                    <label htmlFor="commanSMS" className="form-check-label ms-2" style={{ textWrap: "nowrap" }}>
                                        Comman SMS
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <SelectInputBox
                                id="txtServiceProvider"
                                value={formData.serviceProviderID}
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                label='Service Provider'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, serviceProviderID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtSenderId'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetServiceProviderCode?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <SelectInputBox
                                id="txtSenderId"
                                value={formData.senderID}
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                label='Sender ID'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, senderID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtProductFamilyCode'].focus()
                                    }
                                }}
                            ><option value=''>--Please Select--</option>
                                {GetSenderIdCode?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>

                            <SelectInputBox
                                id="txtProductFamilyCode"
                                value={formData.productFamilyCode}
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                label='Product Family'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, productFamilyCode: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['ddlDealerType'].focus()
                                    }
                                }}
                            ><option value=''>--Please Select--</option>
                                {GetProductFamilyCode?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <SelectInputBox
                                id="ddlDealerType"
                                value={formData.dealerTypeCode}
                                divclassname="col-lg-3 col-md-3 col-sm-12 mb-1"
                                label='Dealer Type'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, dealerTypeCode: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtSMSText'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GeDealerType?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>

                        </div>
                        <div className="mt-2 mb-2">
                            <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" >SMS Text
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <textarea
                                id="txtSMSText"
                                ref={ref => (inputrefs.current["txtSMSText"] = ref)}
                                className="col-lg-6 col-md-6 col-sm-12 form-control"
                                placeholder="SMS Text...."
                                cols={1000}
                                value={formData.smsText}
                                onChange={(e) => setFormData({ ...formData, smsText: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            Export={false}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'SMSTemplateMaster'}
                handleFilter={() => {
                    getSMSTemplateMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                Filter={false}
                filterData={filterData}
                handleEdit={handleEditData }
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default SMSTemplateMaster;
